export const CSRF_HEADER_NAME = 'X-CSRF-Token';

let csrfToken: string | null = null;

export const setCsrfToken = (token: string | null | undefined) => {
    csrfToken = token ?? null;
};

export const getCsrfToken = () => csrfToken;

export const clearCsrfToken = () => {
    csrfToken = null;
};
